const style = {
    topNavBorder: {
        borderBottom: `1px solid`,
        borderBottomColor: "background.second",
        margin: "10px"
    },
    textBorder: {
        display: "flex",
        justifyContent: "center",
        margin: "15px"
    }
}

export default style;